import { Injectable, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
//import { Account } from 'msal';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AccountInfo, AuthenticationResult, EventMessage, EventType, InteractionStatus, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { Client } from '@microsoft/microsoft-graph-client';
import { OAuthSettings } from '../oauth';
import { AlertsService } from './alerts.service';
import { EmployeeService } from './employees.service';
import { Employee } from '../models/models';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable()
export class AuthService {
    public authenticated: boolean = false;
    public access_token: string = '';
    public user: AccountInfo = {} as AccountInfo;
    //private subscription: Subscription;
    private readonly _destroying$ = new Subject<void>();

    constructor(
        private msalService: MsalService,
        private alertsService: AlertsService,
        private msalBroadcastService: MsalBroadcastService,
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private employeeService: EmployeeService
    ) {
        //this.user = this.msalService.getUser();
        //this.user = this.msalService.getAccount();
        this.msalService.initialize().subscribe(result => {
            this.user = this.msalService.instance.getActiveAccount()!;
            this.authenticated = this.user != null;

            console.log("auth.service:constructor", this.user, this.authenticated, result);
        });

        //if (this.authenticated && (this.access_token == '' || this.access_token == null)) {
        //    //this.msalService.acquireTokenSilent(OAuthSettings.scopes, OAuthSettings.authority, this.user);
        //    this.msalService.acquireTokenSilent({
        //        scopes: OAuthSettings.scopes,
        //        authority: OAuthSettings.authority,
        //        account: this.user
        //    });
        //}

        //this.subscription = this.msalBroadcastService.subscribe("msal:loginFailure", (payload) => {
        //    var thisPayload = payload;
        //    console.log('Failed to login: ' + payload);
        //});

        //this.subscription = this.msalBroadcastService.subscribe("msal:loginSuccess", (payload) => {
        //    var thisPayload = payload;
        //    //this.user = this.msalService.getUser();
        //    this.user = this.msalService.instance.getActiveAccount()!;
        //    this.authenticated = true;
        //    this.access_token = payload.accessToken;

        //    this.setLocalStorage();
        //    if (this.authenticated && (this.access_token == '' || this.access_token == null)) {
        //        //this.msalService.acquireTokenSilent(OAuthSettings.scopes, OAuthSettings.authority, this.user);
        //        this.msalService.acquireTokenSilent({
        //            scopes: OAuthSettings.scopes,
        //            authority: OAuthSettings.authority,
        //            account: this.user
        //        });
        //    }

        //    //if (this.router.url.toLowerCase().includes('login')) this.router.navigate(['/home']);
        //});

        //this.subscription = this.msalBroadcastService.subscribe("msal:logoutSuccess", (payload) => {
        //    var thisPayload = payload;
        //});

        //this.subscription = this.msalBroadcastService.subscribe("msal:logoutFailure", (payload) => {
        //    var thisPayload = payload;
        //});

        //this.subscription = this.msalBroadcastService.subscribe("msal:acquireTokenSuccess", (payload) => {
        //    var thisPayload = payload;
        //    this.access_token = payload.accessToken;

        //    this.getUser().then((user) => {
        //        var ok = user;
        //    });
        //});

        //this.subscription = this.msalBroadcastService.subscribe("msal:acquireTokenFailure", (payload) => {
        //    var thisPayload = payload;
        //    if (payload == null || payload.error == null) return;

        //    if (payload.error.indexOf('AADSTS50058') > -1) {
        //        this.signIn();
        //    }

        //    //this.msalService.acquireTokenPopup(OAuthSettings.scopes, OAuthSettings.authority, this.user);
        //});

    }

    public initAuth() {
        this.msalBroadcastService.msalSubject$
            .pipe(
                filter((msg: EventMessage) => msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS)
            )
            .subscribe((result: EventMessage) => {
                console.log("auth.service:initAuth:msalBroadcastService.msalSubject$", result);
                const payload = result.payload as AuthenticationResult;
                this.handleLogin(payload);
            });

        this.msalBroadcastService.inProgress$
            .pipe(
                filter((status: InteractionStatus) => status === InteractionStatus.None)
            )
            .subscribe(() => {
                console.log("auth.service:initAuth:msalBroadcastService.inProgress$");
                let activeAccount = this.msalService.instance.getActiveAccount();
                console.log("auth.service:checkAndSetActiveAccount", activeAccount);

                if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
                    let accounts = this.msalService.instance.getAllAccounts();
                    this.msalService.instance.setActiveAccount(accounts[0]);
                    console.log("auth.service:checkAndSetActiveAccount", activeAccount, accounts);
                }
                //this.setLoginDisplay();
                //this.checkAndSetActiveAccount();
            });
    }

    public handleToken(payload: AuthenticationResult) {
        this.msalService.instance.setActiveAccount(payload.account);
        this.user = this.msalService.instance.getActiveAccount()!;
        this.authenticated = true;
        this.access_token = payload.accessToken;
        this.getUser().then((user) => {
            this.user = user;
            console.log("authService:handleToken", this.user);
            this.setLocalStorage();
        });
    }

    private handleLogin(payload: AuthenticationResult) {
        this.msalService.instance.setActiveAccount(payload.account);
        //this.setLoginDisplay();
        //this.checkAndSetActiveAccount();
        this.user = this.msalService.instance.getActiveAccount()!;
        this.authenticated = true;
        this.access_token = payload.accessToken;

        this.setLocalStorage();
        if (this.authenticated && (this.access_token == '' || this.access_token == null)) {
            this.msalService.acquireTokenSilent({
                scopes: OAuthSettings.scopes,
                authority: OAuthSettings.authority,
                account: this.user
            });
        }

        if (this.router.url.toLowerCase().includes('login')) this.router.navigate(['/home']);
    }

    public loginRedirect() {
        if (this.msalGuardConfig.authRequest) {
            console.log("auth.service:loginRedirect1", "msalGuardConfig.authRequest", this.msalGuardConfig.authRequest);
            this.msalService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
            this.msalService.handleRedirectObservable().subscribe({
                next: (result: AuthenticationResult) => {
                    console.log("auth.service:loginRedirect1", result, "msalGuardConfig.authRequest", this.msalGuardConfig.authRequest);
                    this.handleLogin(result);
                },
                error: (error) => console.log(error)
            });
        } else {
            console.log("auth.service:loginRedirect2");
            this.msalService.loginRedirect();
        }
    }

    public loginPopup() {
        if (this.msalGuardConfig.authRequest) {
            console.log("auth.service:acquireTokenPopup", "msalGuardConfig.authRequest", this.msalGuardConfig.authRequest);
            this.msalService.acquireTokenPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
                .subscribe((response: AuthenticationResult) => {
                    console.log("auth.service:loginPopup1", response, "msalGuardConfig.authRequest", this.msalGuardConfig.authRequest);
                    //this.msalService.instance.setActiveAccount(response.account);
                    //this.user = response.account!;
                    this.handleLogin(response);
                });
                //.subscribe({
                //    next: (result) => {
                //        console.log("auth.service:loginPopup1:next", result);
                //        this.msalService.instance.setActiveAccount(result.account);
                //    },
                //    error: (error) => {
                //        console.log("auth.service:loginPopup1:error", error);
                //    }
                //});

        } else {
            console.log("auth.service:loginPopup2");
            this.msalService.loginPopup()
                .subscribe((response: AuthenticationResult) => {
                    console.log("auth.service:loginPopup2", response, this.msalGuardConfig.authRequest);
                    //this.msalService.instance.setActiveAccount(response.account);
                    //this.user = response.account!;
                    this.handleLogin(response);
                });
                //.subscribe({
                //    next: (result) => {
                //        console.log("auth.service:loginPopup2:next", result);
                //        this.msalService.instance.setActiveAccount(result.account);
                //    },
                //    error: (error) => {
                //        console.log("auth.service:loginPopup2:error", error);
                //    }
                //});

        }
    }

    public logout(popup?: boolean) {
        //if (popup) {
        //    this.msalService.logoutPopup({
        //        mainWindowRedirectUri: "/"
        //    });
        //} else {
        //    this.msalService.logoutRedirect();
        //}
        this.user = {} as AccountInfo;
        this.authenticated = false;
        localStorage.removeItem('EpiEmail');
        localStorage.removeItem('EmployeeId');
        localStorage.removeItem('EmployeeRoles');

        //this.http.post(this.baseUrl + 'api/logout', {}).subscribe(result => {
        //    // ******* THIS DOES NOT WORK *******
        //    // https://stackoverflow.com/questions/62324665/what-is-causing-chrome-to-show-error-the-requests-credentials-mode-prohibits-m
        //    // **********************************

        //    // The browser will receive the Clear-Site-Data header from the server response
        //    // and clear the specified data (cookies, cache, storage, etc.) before this
        //    // callback runs or the page is rendered.
        //    console.log('Logout successful and site data cleared by the browser.');
        //    // Navigate to the login page or home page after the action
        //    //this.router.navigate(['/login']);
        //});

        this.msalService.logoutRedirect();

        console.log("auth.service:logout");
    }

    // Prompt the user to sign in and
    // grant consent to the requested permission scopes
    signIn(): void {
        //this.msalService.acquireTokenPopup({
        //    scopes: OAuthSettings.scopes,
        //    authority: OAuthSettings.authority
        //    //account: this.user
        //}).then(function (loginResponse) {
        //    //login success
        //    let idToken = loginResponse.idToken;
        //}).catch(function (error) {
        //    //login failure
        //    console.log(error);
        //});

        var that = this;

        function authCallback(error, response) {
            //handle redirect response
            if (error) {
                console.error("Redirect error: ", error);
                return;
            }
            console.log("Redirect success: ", response);
            if (that.router.url.toLowerCase().includes('login')) that.router.navigate(['/home']);
        }

        //this.msalService.re.handleRedirectCallback(authCallback);

        //const loginRequest = {
        //    scopes: ["https://graph.microsoft.com/User.ReadWrite"]
        //}

        //const isIE = (typeof window !== 'undefined') ? (window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1) : false;
        const isIE = (window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1);

        this.msalService.loginRedirect({ scopes: OAuthSettings.scopes });
        if (isIE) {
            //this.msalService.loginRedirect(OAuthSettings.scopes);
            this.msalService.loginRedirect({ scopes: OAuthSettings.scopes });
        }
        else {
            //this.msalService.loginRedirect({ scopes: OAuthSettings.scopes });
            this.msalService.loginPopup({ scopes: OAuthSettings.scopes });
        }
        console.log("auth.service:signIn", isIE);
    }

    // Sign out
    signOut(): void {
        this.user = {} as AccountInfo;
        this.authenticated = false;
        localStorage.removeItem('EpiEmail');
        localStorage.removeItem('EmployeeId');
        localStorage.removeItem('EmployeeFullName');
        localStorage.removeItem('EmployeeRoles');
        this.msalService.logout();        
    }

    setLocalStorage() {
        //localStorage.setItem('EpiEmail', this.user.displayableId);
        if (this.user != null) {
            localStorage.setItem('EpiEmail', this.user.username);

            this.http.post<Employee>(this.baseUrl + 'api/User/SetSession', { username: this.user.username }, httpOptions).subscribe(result => {
                this.employeeService.currentEmployee = result;
                localStorage.setItem('EmployeeId', this.employeeService.currentEmployee.employeeId.toString());
                localStorage.setItem('EmployeeFullName', this.employeeService.currentEmployee.fullName);

                this.employeeService.getSearchEmployeeGroupRolesByEmployeeID(result.employeeId).subscribe(roles => {
                    this.employeeService.employeeRoles = roles;
                    localStorage.setItem('EmployeeRoles', this.employeeService.employeeRoles.map(r => r.employeeRoleName).join(','));
                });
            });
        }
    }

    // Silently request an access token
    async getAccessToken(): Promise<string> {
        if (this.access_token != '' && this.access_token != null) return this.access_token;

        var newToken;

        let result = await this.msalService.acquireTokenSilent({
            scopes: OAuthSettings.scopes,
            authority: OAuthSettings.authority,
            account: this.user
        })
            //.catch((reason) => {
            //    console.log('failed to get access token');
            //    //this.alertsService.add('Get token failed', JSON.stringify(reason, null, 2));
            //});
            //.then((token) => {
            //    newToken = token;
            //}, (error) => {
            //    console.log('failed to get access token');
            //    //this.alertsService.add('Get token failed', JSON.stringify(reason, null, 2));
            //});

        //var r = this.msalService.acquireTokenSilent({
        //    scopes: OAuthSettings.scopes,
        //    authority: OAuthSettings.authority,
        //    account: this.user
        //});

        //return result.accessToken;
        return newToken;
    }

    private async getUser(): Promise<AccountInfo> {
        if (!this.authenticated) return {} as AccountInfo;

        let graphClient = Client.init({
            // Initialize the Graph client with an auth
            // provider that requests the token from the
            // auth service
            authProvider: async (done) => {
                let token = await this.getAccessToken()
                    .catch((reason) => {
                        done(reason, null);
                    });

                if (token) {
                    done(null, token);
                    //if (this.router.url.toLowerCase().includes('login')) this.router.navigate(['/home']);
                } else {
                    done("Could not get an access token", null);
                }
            }
        });

        // Get the user from Graph (GET /me)
        //let graphUser = await graphClient.api('/me').get();
        let user = {} as AccountInfo;
        user = this.msalService.instance.getActiveAccount()!;

        return user;
    }

    ngOnDestroy() {
        //this.msalBroadcastService.getMSALSubject().next(1);
        //if (this.subscription) {
        //    this.subscription.unsubscribe();
        //}
        this._destroying$.next(undefined);
        this._destroying$.complete();
    }
}
